import React, { useState, useEffect } from 'react';
import Iframe from 'react-iframe';
import { connect } from 'react-redux';
import { Form, Input, Checkbox, Message } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { apiService } from '../../services';
import { fixID } from '../../helpers';
import { UpdateError, CollectPaymentError, ExelotError } from '../../helpers/fetchErrors';
import { PaymentPageOpts } from '../../helpers/payments';

const RetryDelivery = (props) => {
  const {
    history,
    getRetryDeliveryParcelAPI,
    updateRetryDeliveryParcelAPI,
    collectRetryDeliveryParcelAPI,
    match: { params }
  } = props;

  const [email, setEmail] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [parcelId, setParcelId] = useState(null);
  const [parcelData, setParcelData] = useState(null);
  const [error, setError] = useState();
  const [creditGuardUrl, setCreditGuardUrl] = useState();

  function handleCGPaymentCompletion(opts = {}) {
    console.log('Handling RetryDelivery CG Payment Completion callback');
    const { data } = opts;
    if (!data) {
      console.error('No data found');
      return;
    }

    const { status, page, res } = data;
    if (PaymentPageOpts[page] !== PaymentPageOpts.retryDelivery) {
      console.error(`Unexpected page ${page}`);
      return;
    }
    history.push(`/${page}/callback/${status}`, { ...res });
  }

  useEffect(() => {
    console.log('Adding RetryDelivery listener');
    window.addEventListener('message', handleCGPaymentCompletion, false);

    return () => {
      console.log('Removing RetryDelivery listener');
      window.removeEventListener('message', handleCGPaymentCompletion, false);
    };
  }, []);

  useEffect(() => {
    const id = fixID(params.parcelID);
    if (!id) {
      setError('תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.');
      return;
    }

    setParcelId(id);

    apiService
      .callServer(getRetryDeliveryParcelAPI, { ':id:': id }, null, null, null, true)
      .then(res => {
        setParcelData(res);
      })
      .catch(() => {
        setError('תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.');
      });
  }, []);

  const handleEmail = (e, { value }) => {
    setEmail(value);
  };

  const handleConfirm = () => {
    setConfirmed(!confirmed);
  };

  function updateEmail() {
    return apiService
      .callServer(
        updateRetryDeliveryParcelAPI,
        { ':id:': parcelId },
        null,
        JSON.stringify({ email }),
        null,
        true
      )
      .catch(() => {
        throw new UpdateError();
      });
  }

  function collectPayment() {
    const baseCreditGuardCallbackUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/parcels/creditguard/process_payment?page=retryDelivery&status=:status:`;
    const creditGuardCallbackUrls = {
      success_url: baseCreditGuardCallbackUrl.replace(':status:', 'success'),
      error_url: baseCreditGuardCallbackUrl.replace(':status:', 'error'),
      cancel_url: baseCreditGuardCallbackUrl.replace(':status:', 'cancelled')
    };

    return apiService
      .callServer(
        collectRetryDeliveryParcelAPI,
        { ':id:': parcelId },
        null,
        JSON.stringify({ ...creditGuardCallbackUrls }),
        null,
        true
      )
      .then(res => {
        setCreditGuardUrl(res.url);
      })
      .catch(() => {
        throw new CollectPaymentError();
      });
  }

  const handleSubmit = () => {
    setSubmitted(true);

    updateEmail()
      .then(collectPayment)
      .catch((err) => {
        if (err instanceof ExelotError) {
          setError(err.message);
          return;
        }

        // Should not happen
        console.error(err);

        // Using a default error message
        setError(new UpdateError().message);
      });
  };

  function renderError() {
    if (!error) {
      return null;
    }

    return (
      <Message
        className='error-message'
        error
        content={error}
      />
    );
  }

  if (!parcelData) {
    return renderError();
  }

  if (creditGuardUrl) {
    return (
      <Iframe
        url={creditGuardUrl}
        className='cg-iframe'
      />
    );
  }

  return (
    <div>
      {renderError()}
      {(parcelData.serviceLine === 'SHD')
        ? (
          <div className='sms-content-wrap'>
            <h1>
              התקבל תשלום עבור ביצוע שליחות חוזרת!
            </h1>
            <p style={{ marginTop: '25px' }}>
              <strong>מס’ למעקב: </strong>
              <span>&nbsp; {parcelData.hawb}</span>
            </p>
            <button className='btn medium orange centered' onClick={() => props.history.push(`/tracking/${parcelData.hawb}`)}>מעקב משלוח</button>
          </div>
        ) : (
          (parcelData.hoursLeft !== null && parcelData.hoursLeft > 0)
            ? (
              <div className='sms-content-wrap'>
                <p className='sms-message'>
                  לקוח/ה יקר/ה,<br />
                  חבילה מספר {parcelData.hawb} שנשלחה ע"י חברת אקסלוט, חזרה אלינו מהפצה ראשונה. <br />
                  באפשרותך לשלם עבור הפצה שניה באמצעות שליח. (המשלוח יונח מחוץ לדלת). עלות השירות הינה {parcelData.price} ש"ח בלבד (כולל מע"מ). < br/>
                  <b>ניתן יהיה לעדכן כתובת בהמשך לאחר קבלת הודעה תאום שליח מחברת ההפצה</b>
                </p>

                <Form className='sms-form rtl' onSubmit={handleSubmit}>
                  <Form.Field>
                    <label htmlFor='email'>אנא הזינו כתובת אימייל למשלוח חשבונית:</label>
                    <Input type='email' name='email' required placeholder='אימייל' id='email' value={email} onChange={handleEmail} style={{ direction: 'ltr' }} />
                  </Form.Field>
                  <Form.Field inline>
                    <Checkbox name='confirm' className='rtl' required checked={confirmed} onChange={handleConfirm} />
                    <label className='confirm-label' htmlFor='confirm'>אני מאשר כי פרטי המשלוח הם:</label>
                    <div className='address-wrap'>
                      {parcelData.name}<br />
                      {parcelData.description}
                    </div>
                  </Form.Field>
                  <Form.Field inline>
                    <label>מס’ למעקב:</label>
                    <span>{parcelData.hawb}</span>
                  </Form.Field>
                  <div className='centered'>
                    <button className='btn medium orange' type='submit' disabled={!email || !confirmed || submitted}>המשך לתשלום</button>
                  </div>
                  <div className='centered'>
                    <p className='sms-message' style={{ textDecoration: 'underline', marginTop: '10px' }}>אפשרות הזמנת הפצה חוזרת זמינה עוד <strong>{parcelData.hoursLeft}</strong> שעות</p>
                  </div>
                </Form>
              </div>
            ) : (
              <div className='sms-content-wrap'>
                <h2 className='sms-message'>
                  לקוח/ה יקר/ה,<br />
                  לצערנו חלון הזמן לביצוע הזמנת הפצה חוזרת הסתיים.
                </h2>
              </div>
            )
        )}
    </div>
  );
};

function mapStateToProps(state) {
  const {
    getRetryDeliveryParcel,
    updateRetryDeliveryParcel,
    collectRetryDeliveryParcel
  } = state.api;

  return {
    getRetryDeliveryParcelAPI: getRetryDeliveryParcel,
    updateRetryDeliveryParcelAPI: updateRetryDeliveryParcel,
    collectRetryDeliveryParcelAPI: collectRetryDeliveryParcel
  };
}

const retryDeliveryRouter = withRouter(connect(mapStateToProps)(RetryDelivery));
export { retryDeliveryRouter as RetryDelivery };
